// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2gc-C","label":"CategoryService_label__3LyVj","location":"CategoryService_location__2vfFd"};